import { useMemo } from 'react';
import { defineMessages } from 'react-intl';
import { useSecuritiesContext } from '../../../../contexts';
import { useIntl } from '../../../../hooks';
import { ProductTypeEnum } from '../../../../types';
import { IconName } from '../../../Icons';
import type { FilterableProperty } from '../types';

const messages = defineMessages({
  positionAsset: {
    defaultMessage: 'Position Asset',
    id: 'Filters.FilterBuilder.filters.positionAsset',
  },
});

/**
 * This hook creates the filter property definition for Assets.
 * "Assets" in the frontend are the join of Securities and Currencies.
 *
 * @returns Filter Property definition to use for Asset properties.
 */

export function usePositionAsssetsFilter() {
  const { formatMessage } = useIntl();
  const { securitiesList, securitiesBySymbol } = useSecuritiesContext();

  return useMemo(
    () =>
      ({
        key: 'PositionAssets',
        field: 'PositionAsset',
        label: formatMessage(messages.positionAsset),
        icon: IconName.CurrencyDollar,
        options: [...securitiesList]
          .filter(asset => asset.ProductType === ProductTypeEnum.CFD)
          .map(asset => asset.Symbol),
        getOptionLabel: option => securitiesBySymbol.get(option)?.DisplaySymbol ?? option,
      }) as const satisfies FilterableProperty,
    [formatMessage, securitiesList, securitiesBySymbol]
  );
}
